import React from "react";
import { Reveal, Overline } from "./primitives";
import { PROCESS_STEPS } from "../../data/content";

export default function ProcessSection() {
  return (
    <section className="relative bg-[#FAFAFA] py-20 sm:py-28" data-testid="section-process">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <Overline>How we work</Overline>
            <h2 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-ajmus-ink sm:text-5xl">
              A clear path from first conversation to daily use.
            </h2>
          </div>
        </Reveal>

        <div className="relative mt-16">
          <div className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-health via-ajmus-royal to-edu lg:block" aria-hidden="true" />
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
            {PROCESS_STEPS.map((step, i) => (
              <Reveal key={step.no} delay={i * 0.1}>
                <div className="relative">
                  <span className="relative z-10 flex h-14 w-14 items-center justify-center rounded-2xl border border-black/5 bg-white font-heading text-lg font-black text-ajmus-navy shadow-[0_8px_30px_rgb(11,19,43,0.06)]">
                    {step.no}
                  </span>
                  <h3 className="mt-5 font-heading text-xl font-bold tracking-tight text-ajmus-ink">
                    {step.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-ajmus-steel">{step.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
